export default class ImageLightbox {

  constructor(options = {}) {
    this.selector = options.selector || "img";
    this.items = [];
    this.currentIndex = -1;

    this.createOverlay();
    this.bindGlobalEvents();
  }

  init() {
    this.collectItems();
  }

  collectItems(root = document) {

    this.items = [];
    // Images
    root.querySelectorAll(this.selector).forEach(img => {

      if (img.classList.contains("nonzoomable")) return;
      this.items.push(img);
    });

    this.items.forEach((item, index) => {
      if (item.dataset.lightboxBound)
        return;

      if (item.tagName === "IMG") {

        if (!item.parentElement.classList.contains("lightbox-hover")) {
          const wrapper = document.createElement("div");
          wrapper.className = "lightbox-hover";

          item.parentNode.insertBefore(wrapper, item);
          wrapper.appendChild(item);
        }
      } else {
        item.classList.add("lightbox-hover");
      }

      item.dataset.lightboxBound = "1";
      item.style.cursor = "zoom-in";

      item.addEventListener("click", () => this.openAt(index));
    });
  }

  createOverlay() {

    this.overlay = document.createElement("div");
    this.overlay.className = "lightbox-overlay";

    this.overlay.innerHTML = `
            <div class="lightbox-counter"></div>
            <div class="lightbox-content"></div>
            <button class="lightbox-close">×</button>
            <button class="lightbox-prev">‹</button>
            <button class="lightbox-next">›</button>
        `;

    document.body.appendChild(this.overlay);

    this.content = this.overlay.querySelector(".lightbox-content");
    this.counter = this.overlay.querySelector(".lightbox-counter");

    this.overlay.querySelector(".lightbox-close")
      .addEventListener("click", () => this.close());

    this.overlay.querySelector(".lightbox-prev")
      .addEventListener("click", e => {
        e.stopPropagation();
        this.prev();
      });

    this.overlay.querySelector(".lightbox-next")
      .addEventListener("click", e => {
        e.stopPropagation();
        this.next();
      });

    this.overlay.addEventListener("click", e => {
      if (e.target === this.overlay)
        this.close();
    });
  }

  cleanSrc(src) {
    if (!src)
      return "";

    return src.split("?")[0];
  }

  openAt(index) {

    if (!this.items.length)
      return;

    this.currentIndex = index;

    const item = this.items[index];

    if (!item)
      return;

    this.content.innerHTML = "";

    if (item.tagName === "IMG") {

      const img = document.createElement("img");
      img.className = "lightbox-image";
      img.src = this.cleanSrc(item.src);

      this.content.appendChild(img);
    }
    else {

      const source = item.querySelector("iframe");

      if (!source)
        return;

      let src = source.dataset.src || source.src;

      src += src.includes("?")
        ? "&autoplay=1"
        : "?autoplay=1";

      const iframe = document.createElement("iframe");

      iframe.className = "lightbox-video";
      iframe.src = src;
      iframe.allow = "autoplay; encrypted-media";
      iframe.allowFullscreen = true;

      this.content.appendChild(iframe);
    }

    this.updateCounter();

    this.overlay.classList.add("is-active");
  }

  updateCounter() {
    this.counter.textContent =
      `${this.currentIndex + 1} / ${this.items.length}`;
  }

  next() {
    if (this.currentIndex < this.items.length - 1)
      this.openAt(this.currentIndex + 1);
  }

  prev() {
    if (this.currentIndex > 0)
      this.openAt(this.currentIndex - 1);
  }

  close() {

    this.overlay.classList.remove("is-active");

    this.content.innerHTML = "";

    this.currentIndex = -1;
  }

  bindGlobalEvents() {

    document.addEventListener("keydown", e => {

      if (!this.overlay.classList.contains("is-active"))
        return;

      switch (e.key) {

        case "Escape":
          this.close();
          break;

        case "ArrowRight":
          this.next();
          break;

        case "ArrowLeft":
          this.prev();
          break;
      }
    });
  }
}
